import { render, staticRenderFns } from "./ApiTokenTable.vue?vue&type=template&id=1242ea94"
import script from "./ApiTokenTable.vue?vue&type=script&lang=js"
export * from "./ApiTokenTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports